import { createResource } from "solid-js";
import * as provider from "./providers/entity";
import type { Tile } from "./formatters/ItemFormatter";

export function detailPreload({ params, intent }) {
  const [detail] = createResource(() => ({ ...params }), provider.getInfo);

  if (intent === "preload") {
    return;
  }

  const [credits] = createResource<any, Tile[]>(
    () => ({ ...params }),
    provider.getCredits
  );
  const [recommendations] = createResource<any, Tile[]>(
    () => ({ ...params }),
    provider.getRecommendations
  );

  return { detail, credits, recommendations };
}
